import Vue from 'vue'
import App from './App.vue'

import './plugins/coreAPI'

Vue.filter('niceBytes', x => {
    const units = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    let l = 0,
    n = parseInt(x, 10) || 0;
    while (n >= 1024 && ++l) n = n / 1024;
    return n.toFixed(n < 10 && l > 0 ? 1 : 0) + " " + units[l];
})

import VueRouter from 'vue-router'
import routes from './routes'

Vue.use(VueRouter)
const router = new VueRouter(routes)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
